class Axios {
  configure (axios, token) {
    // If during the sync nexus already have a token, set it to axios
    if (token.isset()) {
      axios.defaults.headers.common['Authorization'] = 'Bearer ' + token.get()
    }

    let retryRunning = false
    let retryBuffer = []

    // Register interceptors in order to renew expired tokens when receiving errors
    axios.interceptors.response.use(undefined, err => {
      return new Promise((resolve, reject) => {
        // If we got a 401 error
        if (typeof(err.response) !== 'undefined' && err.response.status === 401 && err.response.config) {
          // If we have a token to renew and this is not a token regeneration
          if (token.isset() && err.config.url.slice(-24) !== 'account/token/regenerate') {
            // Store the failed query with 401 in a retry buffer
            err.resolve = resolve
            retryBuffer.push(err)
            console.log('[ NEXUS ] Push http query to pending', err.config.url)

            // If there is no retry in progress
            if (!retryRunning) {
              retryRunning = true

              token.refresh()
                .then(result => {
                  // Retry each failed query during the token refresh
                  for (let i = 0; i <= retryBuffer.length; i++) {
                    if (retryBuffer[i]) {
                      let retry = retryBuffer[i]
                      console.log('[ NEXUS ] Execute pending http query', retry.config.url)
                      retry.config.headers.Authorization = 'Bearer ' + token.get()
                      retry.resolve(axios.request(retry.config))
                    }
                  }
                  // Empty the queries and set the retry end
                  retryBuffer = []
                  retryRunning = false
                })
                .catch(error => {
                  console.log('refresh errror', error)
                  token.forget()
                  reject(error)
                })
            }
            // If it is a failed retry or no token to be retried
          } else {
            token.forget()
            reject('No token to be renewed. Session disconnected.')
          }
        } else {
          // If it is a regular error, just reject it
          reject(err)
        }
      })
    })

    // On each token change into nexus, change the token in axios
    token.on('changed', ({token}) => {
      if (token) {
        axios.defaults.headers.common['Authorization'] = 'Bearer ' + token
      } else {
        axios.defaults.headers.common['Authorization'] = ''
      }
    })
  }
}

export let axios = new Axios()



// WEBPACK FOOTER //
// ./libs/@db2b/nexus-js/vendor/axios.js